import { render, staticRenderFns } from "./status-form-location.vue?vue&type=template&id=dc42e0c2&scoped=true&"
import script from "./status-form-location.vue?vue&type=script&lang=js&"
export * from "./status-form-location.vue?vue&type=script&lang=js&"
import style0 from "./status-form-location.vue?vue&type=style&index=0&id=dc42e0c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc42e0c2",
  null
  
)

export default component.exports